export function padLeadingZeros(num: any, size: number) {
  let s = Number(num) + '';
  while (s.length < size) s = '0' + s;
  return s;
}
